Error.stackTraceLimit = Infinity;

declare namespace $ {}
export = $
module.exports
